import { CenteredLayout, ContentHeader, Css } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useDownloadBidSheetV2 } from "src/routes/bids/components/DownloadBidSheetV2Modal";
import { fail, queryResult } from "src/utils";
import { PlanBasedBidPackageFormState, PlanBasedBidPackageWizard } from "../utils";
import { usePlanBasedBidPackageReviewAndDownloadStepQuery } from "./3.ReviewAndDownloadStep.generated";
import { PlanBasedBidsTableV2 } from "./PlanBasedBidsTableV2";

type ReviewAndDownloadStepProps = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  wizard?: PlanBasedBidPackageWizard;
};

export function ReviewAndDownloadStep(props: ReviewAndDownloadStepProps) {
  const { formState, wizard } = props;
  const query = usePlanBasedBidPackageReviewAndDownloadStepQuery({
    variables: { bidPackageId: formState.bidPackageId.value ?? fail("bidPackageId is required") },
  });
  const downloadBidSheetV2 = useDownloadBidSheetV2();
  return queryResult(query, ({ bidPackage }) => (
    <CenteredLayout size="lg">
      <div css={Css.df.fdc.gap3.$}>
        <ContentHeader
          title="Review Bid"
          description="Preview the cost lines below. Return to Step 2 to make changes before creating. After creating, you can edit the bid or download the bid sheet anytime."
          level={2}
          actions={[
            {
              icon: "download",
              label: "Download Bidsheet",
              onClick: () => downloadBidSheetV2(bidPackage),
              variant: "secondaryBlack",
              size: "md",
            },
          ]}
        />
        <PlanBasedBidsTableV2 bidPackage={bidPackage} wizard={wizard} scrollMode="document" />
      </div>
    </CenteredLayout>
  ));
}
